export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc'
}

export interface Sort {
  active: string;
  direction: SortDirection;
}
